import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToast, TOAST_ERROR, TOAST_SUCCESS, FIVE_SECONDS, TEN_SECONDS } from 'lib/utils';
import { makeRemotePatchQueueRequestComment } from 'main/factories/usecases/queue/remote-patch-queue-request-comment';
import { AskRequestComment, AskRequestStatus } from '@hone-automation/common';
import { invalidateQueueRequestsForLocation } from './queueQueryKeys';

const patchQueueComment = async ({ id, comment }: { id: string; comment: string }) => {
  const service = makeRemotePatchQueueRequestComment(id);
  return service.patch({ comment });
};

export const usePatchQueueCommentMutation = (
  status: AskRequestStatus,
  locationId: string,
  onSuccessCallback?: (data: AskRequestComment) => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchQueueComment,
    onSuccess: (data, variables) => {
      // Invalidate old query key format (used by useQueueRequestsQuery)
      queryClient.invalidateQueries({ queryKey: ['queueRequests', status, locationId] });
      // Invalidate new query key format (used by useGetQueueRequestsQuery in QueueContext)
      invalidateQueueRequestsForLocation(queryClient, locationId);
      queryClient.invalidateQueries({ queryKey: ['queueRequestsCount', locationId] });
      queryClient.invalidateQueries({ queryKey: ['flaggedTransactions', locationId] });
      showToast('Comment updated', TOAST_SUCCESS, FIVE_SECONDS);
      if (onSuccessCallback) onSuccessCallback(data as AskRequestComment);
    },
    onError: (error: any) => {
      showToast(error.message || 'Error while updating comment', TOAST_ERROR, TEN_SECONDS);
    },
  });
};
